export default __webpack_public_path__ + "static/media/code.ce649f38.svg";